export const CommonConstants = {
  welcome: 'मेरी दुनिया में आपका स्वागत है',
};
